(ns teamoesterreich.user-mode.location.location-list
  (:require
    [clojure.string]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.add :refer [add]]
    [reagent-material-ui.icons.edit :refer [edit]]
    [reagent-material-ui.icons.home :refer [home]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    [reagent.core :as r]
    [teamoesterreich.config :as config]
    [teamoesterreich.firebase.provider :as provider]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.util.log :as log]

    ))




(defn card [locationId isMain]
  (let [
        !location (r/cursor store/app-state [:locations locationId])
        !selected-location (r/cursor store/app-state [:state :selected-location])
        fav-location (provider/get-fav-locationId)
        location @!location
        lat (and (get-in location [:coordinates]) (.-_lat ^js (get-in location [:coordinates])))
        lng (and (get-in location [:coordinates]) (.-_long ^js (get-in location [:coordinates])))
        makeMainLocation-fn #(a/set-user-fav-location locationId location)
        ]

    [mui/card
     {:className "location-card"}
     [mui/card-content
      {:className "location-card-content"}
      [mui/card-media
       {:component "img"
        :style     {:flex "0 1 400px"}
        :image     (or (:location-picture-path-fst location)
                       (and lat lng
                            (str "https://maps.googleapis.com/maps/api/staticmap?"
                                 "center=" lat "," lng "&zoom=14&size=400x300&"
                                 "markers=color:red|" lat "," lng
                                 "&key=" config/GOOGLE_MAPS_API "&"
                                 ))
                       "/custom/img/home.png")
        :width     "300"
        :height    "200"
        :onClick   (fn []
                     (reset! !selected-location locationId)
                     (a/set-page :prevent-locationView))
        :title     (str (get-in location [:name]))
        :alt       (str (get-in location [:name]))
        }]


      [mui/card-content
       {:style {:flex "1 0 auto"}}
       [mui/typography {:variant "h5" :component "h5"}
        (str (get-in location [:name]))]
       [:br]
       [mui/typography {:variant "body2" :component "p" :color "textSecondary"}
        (str (get-in location [:address]))]
       [:br]
       (if-not isMain
         [mui/button {:variant   "outlined" :startIcon (r/as-element [home])
                      :component "span" :onClick makeMainLocation-fn}
          "Als Wohnadresse machen"]
         [mui/typography {:variant "h5" :component "h5" :color "primary"} "Wohnadresse"])
       [:br]
       [mui/button {:variant   "outlined" :startIcon (r/as-element [edit])
                    :component "span" :onClick (fn []
                                                 (reset! !selected-location locationId)
                                                 (a/set-page :profile-personal-location-form))}
        "Details"]
       ]
      ]]
    ))


(defn get-locations []
  (let [!location-list (r/cursor store/app-state [:locations])
        fav-location (provider/get-fav-locationId)]
    (log/out "Location-list " (clj->js @!location-list))

    (if (empty? @!location-list)
      (do
        [mui/grid
         {:container false
          :item      true
          :lg        10
          :xs        12
          }
         [mui/typography {:variant "h5"} "Bitte erstelle hier Orte für die du dich vorbereiten möchtest."]
         ])
      (doall (for [[locationId location] (sort-by (fn [[id obj]] (if (= fav-location id) 0 1)) @!location-list)]
               ^{:key (str "location-" locationId)} [mui/grid
                                                     {:container false
                                                      :item      true
                                                      :lg        12
                                                      :xs        12

                                                      }
                                                     (card locationId (= fav-location locationId))

                                                     ])))))



(defn get-it []
  (fn []

    [mui/grid
     {:container  true
      :direction  "row"
      :justify    "center"
      :alignItems "stretch"
      :spacing    1
      }

     [mui/grid
      {:container false
       :item      true
       :xs        12
       }
      ""]
     [mui/grid
      {:container false
       :item      true
       :lg        7
       :xs        11
       }

      [mui/grid
       {:container  true
        :direction  "row"
        :justify    "center"
        :alignItems "center"
        :spacing    3
        }

       [mui/grid
        {:container false
         :item      true
         :lg        12
         :xs        12

         }
        [:br]
        [mui/typography {:variant "h5"} "Meine Standorte"]

        (get-locations)

        ]

       [mui/grid
        {:container false
         :item      true
         :xs        6

         }

        [mui/button
         {:variant   "contained"
          :color     "default"
          :class     "bottom-button"
          :onClick   #(a/set-page-back)
          :startIcon (r/as-element [keyboard-arrow-left])
          }
         "Zurück"]]

       [mui/grid
        {:container false
         :item      true
         :xs        6

         }
        [mui/button
         {:variant   "contained"
          :color     "primary"
          :onClick   #(a/set-page :profile-personal-location-create)
          :startIcon (r/as-element [add])
          }
         "Neuer Standort"]]
       ]]]
    ))